(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arb-card-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arb-swatches')) {
    customElements.define(
      'arb-swatches',
      class extends HTMLElement {
        connectedCallback() {
          this.card = this.closest('.card-wrapper, .card');
          this.img = this.card && this.card.querySelector('.card__media img');
          if (!this.img) return;
          this.original = { src: this.img.getAttribute('src'), srcset: this.img.getAttribute('srcset') };
          this.items = [...this.querySelectorAll('.arb-swatches__item[data-src]')];
          this.items.forEach((item) => {
            item.addEventListener('mouseenter', () => this.preview(item));
            item.addEventListener('focus', () => this.preview(item));
          });
          this.addEventListener('mouseleave', () => this.reset());
        }
        preview(item) {
          this.items.forEach((i) => i.classList.toggle('is-active', i === item));
          this.img.setAttribute('srcset', item.dataset.srcset);
          this.img.setAttribute('src', item.dataset.src);
          this.card.classList.add('arb-swatch-preview');
        }
        reset() {
          this.items.forEach((i) => i.classList.remove('is-active'));
          if (this.original.srcset) this.img.setAttribute('srcset', this.original.srcset);
          if (this.original.src) this.img.setAttribute('src', this.original.src);
          this.card.classList.remove('arb-swatch-preview');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["arb-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arb-delivery')) {
    customElements.define(
      'arb-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const lang = document.documentElement.lang || 'tr';
          const min = +this.dataset.min;
          const max = +this.dataset.max;
          const cutoff = +this.dataset.cutoff;
          const now = new Date();
          const shipToday = cutoff > 0 && now.getDay() !== 0 && now.getDay() !== 6 && now.getHours() < cutoff;
          const addBusiness = (date, days) => {
            const d = new Date(date);
            let added = 0;
            while (added < days) {
              d.setDate(d.getDate() + 1);
              if (d.getDay() !== 0 && d.getDay() !== 6) added++;
            }
            return d;
          };
          const start = now;
          const fmt = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'short' });
          this.querySelector('[data-arb-range]').textContent = `${fmt.format(addBusiness(start, min))} – ${fmt.format(addBusiness(start, max))}`;

          const row = this.querySelector('[data-arb-countdown-row]');
          const out = this.querySelector('[data-arb-countdown]');
          if (!shipToday) return;
          row.hidden = false;
          const tick = () => {
            const end = new Date();
            end.setHours(cutoff, 0, 0, 0);
            const diff = Math.max(0, end - new Date());
            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            out.textContent = `${h} sa ${m} dk ${String(s).padStart(2, '0')} sn`;
            if (diff === 0) {
              clearInterval(this.timer);
              row.hidden = true;
            }
          };
          tick();
          this.timer = setInterval(tick, 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
